module.exports = __webpack_public_path__ + "static/media/logo_small.c29777d3.png";